<template>
  <div>
    <div class="pb-4">
      <span class="text-chips md:block md:text-center">Paso Dos: </span>
      <h2 class="headline-sm pb-1 md:headline-md md:text-center">Educación</h2>
      <p class="subhead-2 text-on-surface-variant md:subhead-1 md:text-center">
        Ingresa los datos de tu formación académica, certificaciones, etc.
      </p>
    </div>
    <div class="flex flex-col gap-4">
      <CvSectionCrud
        title="Educación"
        :content="education_records_transformed"
        contentKey="education_records"
        @edit-record="editRecord"
        @add-record="addRecord"
      />
      <CvSectionCrud
        :content="languages_records_transformed"
        title="Idiomas"
        cardType="pill"
        contentKey="languages_records"
        @edit-record="editRecord"
        @add-record="addRecord"
      />
    </div>

    <modal
      name="education_records"
      height="auto"
      :clickToClose="false"
      :reset="true"
      :adaptive="true"
      :scrollable="true"
      classes="!surface-1 md:!rounded-xl !overflow-y-auto"
    >
      <EducationForm
        :educational_degrees_options="educational_degrees_options"
        :educational_institutions_options="educational_institutions_options"
        :study_fields_options="study_fields_options"
        :previousForm="recordToEdit !== null ? recordToEdit : {}"
        @close="
          $modal.hide('education_records')
          resetModalData()
        "
        @emit-record="saveRecord('education_records', $event)"
      />
    </modal>
    <modal
      name="languages_records"
      height="auto"
      :clickToClose="false"
      :reset="true"
      :adaptive="true"
      :scrollable="true"
      classes="!surface-1 md:!rounded-xl !overflow-y-auto"
    >
      <LanguageForm
        :language_options="language_options"
        :language_proficiency_options="language_proficiency_options"
        :previousForm="recordToEdit !== null ? recordToEdit : {}"
        @close="
          $modal.hide('languages_records')
          resetModalData()
        "
        @emit-record="saveRecord('languages_records', $event)"
      />
    </modal>
  </div>
</template>

<script>
import { validateRequiredKeys } from '@/utilities.helpers.js'

export default {
  name: 'CreateProfile_StepTwo',
  components: {
    CvSectionCrud: () => import('@/Components/CrearPerfil/CvSectionCrud.vue'),
    EducationForm: () => import('@/Components/Perfil/EducationForm.vue'),
    LanguageForm: () => import('@/Components/Perfil/LanguageForm.vue'),
  },
  props: {
    config: {
      type: Object,
      validator: value => {
        return validateRequiredKeys(value, ['form_data', 'options_data'])
      },
    },
  },
  data() {
    return {
      recordToEdit: null,
      recordToEditKey: null,
      contentKey: '',
      language_options: this.config.options_data.language?.language_options,
      language_proficiency_options: this.config.options_data.language?.language_proficiency_options,
      educational_institutions_options: this.config.options_data.education
        .educational_institutions_options,
      educational_degrees_options: this.config.options_data.education.educational_degrees_options,
      study_fields_options: this.config.options_data.education.study_fields_options,
      education_records: this.config.form_data.education,
      languages_records: this.config.form_data.languages,
    }
  },
  computed: {
    education_records_transformed() {
      return this.education_records.length > 0
        ? this.education_records.map(item => {
            return {
              title: item.title,
              description: item.description,
              subtitle: item.educational_institution_name_aux
                ? item.educational_institution_name_aux
                : item.educational_institution_name,
              initDate: item.start_date,
              finishDate: item.finish_date,
            }
          })
        : []
    },
    languages_records_transformed() {
      return this.languages_records.length > 0
        ? this.languages_records.map(item => {
            return {
              title: item.language_name,
              subtitle: item.language_proficiency_level_name,
            }
          })
        : []
    },
  },
  methods: {
    editRecord(contentKey, recordKey) {
      this.contentKey = contentKey
      this.recordToEdit = this[contentKey][recordKey]
      this.recordToEditKey = recordKey
      this.$modal.show(contentKey)
    },
    addRecord(contentKey) {
      this.contentKey = contentKey
      this.$modal.show(contentKey)
    },
    saveRecord(contentKey, recordData) {
      if (this.recordToEditKey === null) this[contentKey].push(recordData)
      else this.updateContent(contentKey, this.recordToEditKey, recordData)
      this.resetModalData()
      this.$modal.hide(contentKey)
    },
    resetModalData() {
      this.contentKey = ''
      this.recordToEdit = null
      this.recordToEditKey = null
    },
    updateContent(contentKey, contentRecordKey, updatedData) {
      this.$set(this[contentKey], contentRecordKey, updatedData)
    },
  },
  watch: {
    education_records: {
      deep: true,
      handler(value) {
        this.$emit('update-content', 'education', value)
      },
    },
    languages_records: {
      deep: true,
      handler(value) {
        this.$emit('update-content', 'languages', value)
      },
    },
  },
}
</script>
